import React, { FC, useEffect, useState } from "react";
import classes from "./style/UI_ITOModuleSuccess.module.css";
import { CheckCircleTwoTone } from "@ant-design/icons";

interface IUI_ITOModuleSuccess {
  title: string;
  isSuccess: boolean;
}

export const UI_ITOModuleSuccess: FC<IUI_ITOModuleSuccess> = ({
  title,
  isSuccess,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isSuccess) {
      const timeout = setTimeout(() => {
        setIsVisible(true);
      }, 1000);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [isSuccess]);

  if (!isVisible) {
    return null;
  }

  return (
    <div className={classes.successEdit}>
      <CheckCircleTwoTone twoToneColor="#52c41a" />
      {title}
    </div>
  );
};
